import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FancyStateIcon } from 'ui-components/components/fancy-state-icon';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalCloseButton } from 'ui-components/components/modal/modal-close-button';
import { Text, TextType } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { ModalPortal } from '../../../../../../components/modal-portal';
import { freightInventoryWarningModalMessages as messages } from './freight-inventory-warning-modal-messages';

import style from './freight-inventory-warning-modal.module.less';

const WARNING_STATE = 'warning';

type FreightInventoryWarningModalProps = {
  message: string;
  onContinue: () => void;
  onClose: () => void;
};

export const FreightInventoryWarningModal = ({ message, onContinue, onClose }: FreightInventoryWarningModalProps) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['warning-modal']}>
        <ModalBody className={style.body}>
          <FlexRow className={style['title-row']} gap={Gap.Space12}>
            <div className={style['state-icon-wrapper']}>
              <FancyStateIcon state={WARNING_STATE} />
            </div>
            <Text className={style.title} isBold textType={TextType.H4} value={messages.title} />
            <div className={style['close-button-wrapper']}>
              <ModalCloseButton closeModal={onClose} />
            </div>
          </FlexRow>
          <Text className={style.message} textType={TextType.Paragraph} value={message} />
        </ModalBody>
        <ModalFooter>
          <FlexRow className={style.footer} gap={Gap.Space8}>
            <Button onClick={onClose} theme={THEME_CONSTANTS.tertiary}>
              <FormattedMessage {...messages.cancel} />
            </Button>
            <Button onClick={onContinue} theme={THEME_CONSTANTS.primary}>
              <FormattedMessage {...messages.continue} />
            </Button>
          </FlexRow>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};
